import styled from 'styled-components';

const IconBtn = styled.span`
  color: #757575;
  height: 28px;
  font-size: 22px;
  line-height: 28px;
  padding: 0 4px;
  margin: 12px 0 12px 8px;
  border-radius: 5px;
  &:hover {
    background: #f7f7f7;
  }
`;
export default IconBtn;
